import {
  ContractSituationDetail,
  FormattedOwnerData,
  OwnerData,
  OwnerDataCups,
} from "../../core/models/ownerData/ownerData.model";

export const formatContractSituation = (
  situationCode: number,
): ContractSituationDetail => {
  switch (situationCode) {
    case 1:
      return "Contrato";
    case 2:
      return "Baja";
    case 3:
      return "Rechazo ATR";
    case 4:
      return "Solicitado distribuidora";
    case 5:
      return "Incidencia";
    case 6:
      return "Cortado";
    case 7:
      return "Inspección Alta";
    case 8:
      return "Scoring";
    case 9:
      return "Scoring Rechazado";
    case 10:
      return "Oferta Enviada";
    case 11:
      return "Oferta Pendiente";
    case 12:
      return "Contrato Firmado";
    case 13:
      return "Contrato No Firmado";
    case 14:
      return "En trámite Switching";
    case 15:
      return "Pendiente Comercial SW";
    case 16:
      return "Scoring Análisis";
    case 17:
      return "Oferta rechazada";
    case 18:
      return "Anulado";
    case 19:
      return "Baja por modificación";
    case 20:
      return "Pendiente Renovación";
    case 21:
      return "Renovación aceptada";
    case 22:
      return "Baja por Renovación";
    case 23:
      return "Trámite Renovación";
    case 28:
      return "Renovación Rechazada";
    case 29:
      return "Baja Punto de Recarga";
    case 30:
      return "Scoring Pendiente Doc.";
    case 31:
      return "Pendiente Firma";
    case 32:
      return "Caducado Firma";
    case 33:
      return "Renovación Pendiente Comercial";
    case 34:
      return "Baja por renovación rechazada";
    case 37:
      return "Pendiente Firma Renovacion";
    case 42:
      return "Caducado Firma Renovacion";
    case 43:
      return "Oferta Caducada";
    case 47:
      return "Pte Comercial";
    case 48:
      return "Oferta Anulada";
    default:
      return "";
  }
};

const formatOwnerData = (ownerData: OwnerData): FormattedOwnerData => {
  const {
    IsAdministrador: isAdministrator,
    DatosPersonales: personalData,
    DatosAdministrador: administratorData,
    NumeroSuministros,
    CUPS,
    flags,
  } = ownerData;

  return {
    isAdministrator,
    firstClientSurname: personalData?.Apellido1Cliente || "",
    secondClientSurname: personalData?.Apellido2Cliente || "",
    clientName: personalData?.NombreCliente || "",
    clientIdentification: personalData?.IdentificadorClienteDNI || "",
    socialReason: personalData?.RazonSocialCliente || "",
    idClient: personalData?.IdCliente.toString() || "",
    administratorName: administratorData?.NombreAdministrador || "",
    idAdministrator: administratorData?.IdAdministrador || "",
    entitiesNumber: administratorData?.NumeroEntidades || "",
    supplyNumber: NumeroSuministros || "",
    cups: CUPS?.length
      ? CUPS.map(
          ({
            CodigoCups,
            IdCups,
            IdContrato,
            IdentidadTitular,
            Entorno,
            Calle,
            Numero,
            Tarifa,
            Ciudad,
            CodigoContrato,
            RazonSocial,
            IdContratoSituacion,
            FechaAlta,
          }) => ({
            codeCups: CodigoCups,
            idCups: IdCups,
            idContract: IdContrato,
            cif: IdentidadTitular,
            envirorment: Entorno,
            fee: Tarifa,
            address: `${Calle}${Numero ? ", " + Numero : ""}`,
            town: Ciudad,
            contractCode: CodigoContrato,
            socialReason: RazonSocial,
            situation: IdContratoSituacion === 1 ? "Contrato" : "",
            contractSituationDetail:
              formatContractSituation(IdContratoSituacion),
            date: FechaAlta,
          }),
        )
      : [],
    isAgent: flags.EsAgente || false,
  };
};

const initialOwnerDataCup: OwnerDataCups = {
  idCups: "",
  idContract: "",
  codeCups: "",
  address: "",
  cif: "",
  fee: "",
  envirorment: "",
  town: "",
  contractCode: "",
  socialReason: "",
  date: "",
  situation: "",
  contractSituationDetail: "",
};

export { formatOwnerData, initialOwnerDataCup };
